import React, { useEffect, useState } from 'react';
import Tooltip from '@ui-kit/components/tooltip';
import styles from './ladderPointsStatement.module.scss';
import { ReactComponent as QuestionMark } from '../../../assets/question_mark.svg';
import { Statement, StatementEvent } from '../../../model/interfaces';
import DataTable from '../../../../../ui/components/dataTable';
import statementColumns from './statementColumns';
import Modal from '@ui-kit/components/modal';
import { container } from 'tsyringe';
import {
  AdditionalType,
  TournamentsService,
} from '@base/features/tournaments/model/interfaces';
import { Loader } from '@ui-kit/components/loader';
import { FinishedTournamentAdditional } from '../../../../tournaments/components/finishedTournaments/finishedAdditional/finishedTournamentAdditional';
import { t } from '@base/utils/helpers';

export default function LadderPointsStatement(props: {
  statement?: Statement;
  ladderPoints?: number;
}) {
  const tournamentService: TournamentsService =
    container.resolve('tournamentsService');
  const [tourneyID, setTourneyID] = useState<string>();
  const [tournament, setTournament] = useState<AdditionalType>();

  useEffect(() => {
    (async () => {
      if (tourneyID) {
        const tournament = (await tournamentService.getTourney(tourneyID))
          .tourney;
        setTournament({
          tourneyID: tournament.TourneyID,
          startTime: tournament.StartTime,
          checkIn: '?',
          component: '?',
          directorId: tournament.Director,
          directorName: tournament.DirectorName,
          pairing: tournament.PairingType,
          timeControl: tournament.TimeControl,
          entryFee: tournament.EntryFee,
          description: tournament.Description,
          extraBonus: tournament.ExtraBonus,
          firstPrizeUsr: tournament.FirstPrizeUsr,
          firstPrizeAmt: tournament.FirstPrizeAmt,
          secondPrizeUsr: tournament.SecondPrizeUsr,
          secondPrizeAmt: tournament.SecondPrizeAmt,
          thirdPrizeUsr: tournament.ThirdPrizeUsr,
          thirdPrizeAmt: tournament.ThirdPrizeAmt,
          fourthPrizeUsr: tournament.FourthPrizeUsr,
          fourthPrizeAmt: tournament.FourthPrizeAmt,
        });
      } else {
        setTournament(undefined);
      }
    })();
  }, [tourneyID, tournamentService]);

  return props.statement?.events ? (
    <div className={styles.statement}>
      <header>
        <div className={styles.tooltipHeader}>
          <h3>{t('ladder_points')}</h3>
          <Tooltip overlay={<LadderRules />} trigger="hover">
            <QuestionMark />
          </Tooltip>
        </div>
        <h3>{t('ladder_position', props.ladderPoints?.toString() || '?')}</h3>
      </header>
      <div className={styles.table}>
        <DataTable<StatementEvent>
          columns={statementColumns}
          data={props.statement?.events}
          onRowClick={(event) => setTourneyID(event.tourneyID)}
        />
      </div>
      {tourneyID && (
        <Modal
          classes={{ body: styles.modalBody }}
          title="Tourney info"
          headerBtn
          closeModal={() => setTourneyID(undefined)}
        >
          {tournament ? (
            <FinishedTournamentAdditional data={tournament} />
          ) : (
            <Loader />
          )}
        </Modal>
      )}
    </div>
  ) : null;
}

const LadderRules = () => (
  <ul className={styles.statementInfo}>
    {new Array(4).fill(0).map((_, i) => (
      <li>{t(`ladder_points_rule_${i + 1}`)}</li>
    ))}
  </ul>
);
